import { useEffect, useState } from "react"
import { useFetch } from "../../../common/hooks/useFetch"
import { countEmployeesOrganizationService } from "../services/countEmployeesOrganization.service"

export const useEmployeesOrganizationQuery = () => {
  const fetchData = useFetch()
  const [employeesOrganization, setEmployeesORganization] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchEmployeesOrganization = async () => {
      try {
        const response = await countEmployeesOrganizationService(fetchData)()
        setEmployeesORganization(Number(response).toFixed(1))
        setLoading(false)
      } catch (error) {
        console.error('Error fetching employees organization:', error)
        setLoading(false)
      }
    }

    fetchEmployeesOrganization()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { employeesOrganization, loading }
}
